import { addLastPrefixTW } from '../transforms/addLastPrefix';
import { formatOrdinalTW } from '../transforms/formatOrdinal';
import { overrideBaseLocale } from './base-config';
export var zhTW = overrideBaseLocale('zh-TW', {
    dayOfMonthOrdinal: {
        options: {
            day: 'numeric',
        },
        transforms: [formatOrdinalTW],
    },
    dayOfMonth: {
        options: {
            day: 'numeric',
        },
        transforms: [addLastPrefixTW],
    },
});
//# sourceMappingURL=zh-TW.js.map